var _g, _g2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMale = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0427\\u043E\\u043B\\u043E\\u0432\\u0456\\u0447\\u0456",
    width: 54.456,
    height: 54.456,
    viewBox: "0 0 54.456 54.456",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-1",
    d: "M50.468,0H35.312a3.191,3.191,0,1,0,0,6.382h8.251L34.344,15.6a21.3,21.3,0,0,0-12.806-4.22A21.538,21.538,0,1,0,43.076,32.918a21.3,21.3,0,0,0-4.22-12.806l9.219-9.219v8.251a3.191,3.191,0,1,0,6.382,0V3.989A3.993,3.993,0,0,0,50.468,0Zm2.393,19.145a1.6,1.6,0,1,1-3.191,0V8.968A.8.8,0,0,0,48.308,8.4L37.234,19.479a.8.8,0,0,0-.061,1.06,19.732,19.732,0,0,1,4.308,12.38A19.943,19.943,0,1,1,21.538,12.976a19.733,19.733,0,0,1,12.38,4.308.8.8,0,0,0,1.06-.061L46.052,6.148a.8.8,0,0,0-.564-1.362H35.312a1.6,1.6,0,0,1,0-3.191H50.468a2.4,2.4,0,0,1,2.393,2.393Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(4.796 16.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-1",
    d: "M61.785,152a16.817,16.817,0,0,0-10.623,3.789.8.8,0,1,0,1.012,1.237,15.187,15.187,0,1,1-2.148,2.148.8.8,0,1,0-1.237-1.012,16.785,16.785,0,1,0,13-6.162Z",
    transform: "translate(-45 -152)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMale, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/male.4e5f9998.svg";
export { ForwardRef as ReactComponent };